
export default {
  swagger: { url: '/api/schema/', method: 'GET' },
  settings: { url: '/settings/', method: 'GET' },
  linkImageUploader: { url: '/uploader/upload/link_preview/', method: 'POST' },
  token_auth: { url: '/accounts/connect_with_token/', method: 'POST' },
  ai_chat_token: { url: '/org/ai-chat-token/', method: 'POST' },
  sendbird: {
    token: { url: '/org/sendbird/token/', method: 'GET' },
    group_create: { url: '/org/sendbird/create_group_chat/', method: 'POST' },
    multi_message: {
      list: { url: '/org/sendbird/multi_message/', method: 'GET' },
      send: { url: '/org/sendbird/multi_message/', method: 'POST' },
      info: { url: '/org/sendbird/multi_message/:id/', method: 'GET' },
      retry: { url: '/org/sendbird/multi_message/:id/retry_failed/', method: 'POST' }
    },
    templates: {
      list: { url: '/org/sendbird/message_templates/', method: 'GET' },
      create: { url: '/org/sendbird/message_templates/', method: 'POST' },
      get: { url: '/org/sendbird/message_templates/:id/', method: 'GET' },
      update: { url: '/org/sendbird/message_templates/:id/', method: 'PUT' },
      remove: { url: '/org/sendbird/message_templates/:id', method: 'DELETE' },
      variables: { url: '/org/sendbird/message_templates/available_variables', method: 'GET' }
    }
  },
  contact_details: {
    get: { url: '/org/contact/base/', method: 'GET' },
    update: { url: '/org/contact/base/', method: 'PUT' }
  },
  shopify: {
    status: { url: '/org/shopify/status/', method: 'GET' },
    create_token: { url: '/org/api-keys/', method: 'POST' },
    get_tokens: { url: '/org/api-keys/', method: 'GET' },
    get_token: { url: '/org/api-keys/:id/', method: 'GET' },
    search_products: { url: '/org/shopify/search-products/', method: 'GET' },
    search_collections: { url: '/org/shopify/search-collections/', method: 'GET' },
    search_product_types: { url: '/org/shopify/search_product_types/', method: 'GET' },
    collection_products: { url: '/org/shopify/collection-products/', method: 'GET' },
    collection_variant_count: { url: '/org/shopify/collections/variant-count/', method: 'GET' },
    product_variants: { url: '/org/shopify/product-variants/', method: 'GET' },
    variant_stock: { url: '/org/shopify/variant-stock/', method: 'POST' }
  },
  networkMerchant: {
    status: { url: '/org/network_merchant/status/', method: 'GET' },
    rate: { url: '/org/network_merchant/rate/', method: 'PUT' },
    locking_window: { url: '/org/network_merchant/locking-window/', method: 'PUT' },
    request_activation: { url: '/org/network_merchant/request-activation/', method: 'POST' }
  },
  networkOrders: {
    list: { url: '/org/network_orders/', method: 'GET' },
    summary: { url: '/org/network_orders/summary/', method: 'GET' },
    detail: { url: '/org/network_orders/:id/', method: 'GET' },
    cancel: { url: '/org/network_orders/:id/cancel/', method: 'POST' }
  },
  commissionRules: {
    list: { url: '/org/commission_rules/', method: 'GET' },
    create: { url: '/org/commission_rules/', method: 'POST' },
    update: { url: '/org/commission_rules/:id/', method: 'PATCH' },
    remove: { url: '/org/commission_rules/:id/', method: 'DELETE' },
    reorder: { url: '/org/commission_rules/:id/reorder/', method: 'PUT' }
  },
  contact_invoice: {
    get: { url: '/org/contact/invoice/', method: 'GET' },
    update: { url: '/org/contact/invoice/', method: 'PUT' }
  },
  help: {
    faq: { url: '/public/faq/', method: 'GET' },
    definitions: { url: '/public/definitions/', method: 'GET' }
  },
  invitations: {
    get: { url: '/org/invitations/', method: 'GET' },
    invite: { url: '/org/invitations/', method: 'POST' },
    delete: { url: '/org/invitations/:id/', method: 'DELETE' },
    resend: { url: '/org/invitations/:id/resend/', method: 'POST' }
  },
  members: {
    get: { url: '/org/members/', method: 'GET' },
    delete: { url: '/org/members/:id/', method: 'DELETE' }
  },
  analytics: {
    links: { url: '/org/analytics/by_link/', method: 'POST' },
    links_report: { url: '/org/analytics/request_by_links_csv/', method: 'POST' },
    users: { url: '/org/analytics/by_user/', method: 'POST' },
    users_report: { url: '/org/analytics/request_by_user_csv/', method: 'POST' },
    tags: { url: '/org/analytics/tags/', method: 'GET' },
    campaign_modifiers: { url: '/org/analytics/campaign_modifiers/', method: 'GET' },
    campaigns: { url: '/org/analytics/by_campaign/', method: 'POST' }
  },
  creator_object: {
    creator_details_public: { url: '/org/user_objects/by_public_id/:id/', method: 'GET' },
    creator_details_custom: { url: '/org/user_objects/by_custom_id/:id/', method: 'GET' },
    creator_details_sendbird: { url: '/org/user_objects/by_sendbird_id/:id/', method: 'GET' },
    similar_creators: { url: '/org/similar_creators/:id/', method: 'GET' },
    signals_public: { url: '/org/analytics/creator_signals/by_public_id/:id/', method: 'GET' },
    signals_custom: { url: '/org/analytics/creator_signals/by_custom_id/:id/', method: 'GET' },
    notes: {
      public: {
        list: { url: '/org/user_objects/by_public_id/:id/notes/', method: 'GET' },
        create: { url: '/org/user_objects/by_public_id/:id/notes/', method: 'POST' },
        update: { url: '/org/user_objects/by_public_id/:id/notes/:noteId/', method: 'PATCH' },
        remove: { url: '/org/user_objects/by_public_id/:id/notes/:noteId/', method: 'DELETE' }
      },
      custom: {
        list: { url: '/org/user_objects/by_custom_id/:id/notes/', method: 'GET' },
        create: { url: '/org/user_objects/by_custom_id/:id/notes/', method: 'POST' },
        update: { url: '/org/user_objects/by_custom_id/:id/notes/:noteId/', method: 'PATCH' },
        remove: { url: '/org/user_objects/by_custom_id/:id/notes/:noteId/', method: 'DELETE' }
      },
      chat: {
        list: { url: '/org/user_objects/by_sendbird_id/:id/notes/', method: 'GET' },
        create: { url: '/org/user_objects/by_sendbird_id/:id/notes/', method: 'POST' },
        update: { url: '/org/user_objects/by_sendbird_id/:id/notes/:noteId/', method: 'PATCH' },
        remove: { url: '/org/user_objects/by_sendbird_id/:id/notes/:noteId/', method: 'DELETE' }
      }
    }
  },
  discover: {
    get: { url: '/org/discover/search/', method: 'POST' },
    bulk_update: { url: '/org/discover/', method: 'PATCH' },
    getUser: { url: '/org/discover/:id/', method: 'GET' },
    updateUser: { url: '/org/discover/:id/', method: 'PUT' },
    tags: { url: '/org/discover_tags/', method: 'GET' },
    tagsBulk: { url: '/org/discover/add_tags/', method: 'POST' },
    brands: { url: '/org/discover/brands/', method: 'GET' },
    categories: { url: '/org/discover/categories/', method: 'GET' },
    linkCategories: { url: '/org/discover/link_categories/', method: 'GET' }
  },
  recommended_creators: { url: '/org/recommended_creators/', method: 'GET' },
  data_export: {
    get: { url: '/org/data_export/', method: 'GET' }
  },
  profile: {
    details: { url: '/my/profile/', method: 'GET' },
    email_edit: { url: '/my/profile/email/', method: 'PUT' },
    name_edit: { url: '/my/profile/name/', method: 'PUT' },
    password_reset: { url: '/my/profile/password-send-reset-email/', method: 'POST' },
    phone_edit: { url: '/my/profile/phone/send-code/', method: 'POST' },
    phone_verify: { url: '/my/profile/phone/verify/', method: 'POST' },
    avatar_update: { url: '/my/profile/avatar/', method: 'PUT' },
    avatar_delete: { url: '/my/profile/avatar/', method: 'DELETE' }
  },
  accept_invitation: {
    sign_up: { url: '/accounts/organizations/invitation_accept/', method: 'POST' }
  },
  secret_settings: {
    login: { url: '/accounts/organizations/sign_in/', method: 'POST' }
  },
  store_domains: {
    list: { url: '/org/store_domains/', method: 'GET' },
    get: { url: '/org/store_domains/:id/', method: 'GET' },
    update: { url: '/org/store_domains/:id/', method: 'PATCH' },
    create: { url: '/org/store_domains/', method: 'POST' },
    delete: { url: '/org/store_domains/:id/', method: 'DELETE' },
    verify: { url: '/org/store_domains/:id/verify/', method: 'POST' }
  },
  refer: {
    connections: { url: '/org/referrals/connections/', method: 'GET' },
    latest: { url: '/org/referrals/links/latest/', method: 'GET' },
    invite: { url: '/org/referrals/send_mail/', method: 'POST' },
    links: { url: '/org/referrals/links/', method: 'GET' },
    create: { url: '/org/referrals/links/', method: 'POST' }
  },
  dashboard: { url: '/my/dashboard/', method: 'GET' },
  stripeBilling: { url: '/my/stripe/billing_portal/sessions/', method: 'POST' },
  verifiedDomains: { url: '/org/domains_verified/', method: 'GET' },
  unmasking: {
    connections: {
      list: { url: '/org/unmasking/connections/', method: 'GET' },
      search: { url: '/org/unmasking/connections/search/', method: 'POST' },
      get: { url: '/org/unmasking/connections/:id/', method: 'GET' }
    },
    invitations: {
      list: { url: '/org/unmasking/invitations/', method: 'GET' },
      send: { url: '/org/unmasking/invitations/', method: 'POST' },
      get: { url: '/org/unmasking/invitations/:id/', method: 'GET' },
      withdraw: { url: '/org/unmasking/invitations/:id/withdraw/', method: 'PUT' }
    }
  },
  modifiers: {
    assignments: {
      list: { url: '/org/modifiers/assignments/', method: 'GET' },
      create: { url: '/org/modifiers/assignments/', method: 'POST' },
      get: { url: '/org/modifiers/assignments/:id/', method: 'GET' },
      update: { url: '/org/modifiers/assignments/:id/', method: 'PUT' },
      updatePatch: { url: '/org/modifiers/assignments/:id/', method: 'PATCH' },
      remove: { url: '/org/modifiers/assignments/:id/', method: 'DELETE' },
      archive: { url: '/org/modifiers/assignments/:id/archive/', method: 'PUT' },
      uniqueName: { url: '/org/modifiers/assignments/name/make_unique/', method: 'POST' },
      addUsers: { url: '/org/modifiers/assignments/:id/users/add/', method: 'POST' },
      removeUsers: { url: '/org/modifiers/assignments/:id/users/remove/', method: 'POST' },
      check_balance: { url: '/org/modifiers/assignments/check_balance/', method: 'POST' },
      summary: { url: '/org/campaigns/basic/:id/', method: 'GET' },
      participants: { url: '/org/campaigns/basic/:id/participants/', method: 'POST' }
    },
    regularusers: {
      list: { url: '/org/modifiers/groups/regularusers/', method: 'GET' },
      create: { url: '/org/modifiers/groups/regularusers/', method: 'POST' },
      get: { url: '/org/modifiers/groups/regularusers/:id/', method: 'GET' },
      update: { url: '/org/modifiers/groups/regularusers/:id/', method: 'PATCH' },
      remove: { url: '/org/modifiers/groups/regularusers/:id/', method: 'DELETE' },
      addUsers: { url: '/org/modifiers/groups/regularusers/:id/users/add/', method: 'POST' },
      removeUsers: { url: '/org/modifiers/groups/regularusers/:id/users/remove/', method: 'POST' },
      members: {
        list: { url: '/org/modifiers/groups/regularusers/:id/members/', method: 'GET' }
      }
    },
    smartgroup: {
      create: { url: '/org/modifiers/groups/smart/', method: 'POST' },
      get: { url: '/org/modifiers/groups/smart/:id/', method: 'GET' },
      update: { url: '/org/modifiers/groups/smart/:id/', method: 'PUT' },
      remove: { url: '/org/modifiers/groups/smart/:id/', method: 'DELETE' },
      refresh: { url: '/org/modifiers/groups/smart/:id/refresh/', method: 'POST' }
    }
  },
  baseCommissionRate: { url: '/org/commission_rates/base-rate/', method: 'GET' },
  promotions: {
    list: { url: '/org/promotions/', method: 'GET' },
    create: { url: '/org/promotions/', method: 'POST' },
    get: { url: '/org/promotions/:id/', method: 'GET' },
    update: { url: '/org/promotions/:id/', method: 'PATCH' },
    remove: { url: '/org/promotions/:id/', method: 'DELETE' }
  },
  billing: {
    info: { url: '/org/billing/overview/info/', method: 'GET' },
    credits: {
      balance: { url: '/org/billing/credits/balance/', method: 'GET' },
      transactions: { url: '/org/billing/credits/ledger/', method: 'GET' },
      transactions_subtotal: { url: '/org/billing/credits/ledger/subtotal/', method: 'GET' },
      locks: { url: '/org/billing/credits/locks/', method: 'GET' },
      add: { url: '/org/billing/credits/prepayment/', method: 'POST' },
      add_preview: { url: '/org/billing/credits/prepayment/preview/', method: 'GET' },
      fees: { url: '/org/billing/credits/fees/', method: 'GET' }
    },
    invoices: { url: '/org/billing/invoices/', method: 'GET' },
    subscription: {
      get: { url: '/org/billing/subscription/', method: 'GET' },
      portal: { url: '/org/billing/subscription/portal/', method: 'POST' },
      upgrade: { url: '/org/billing/subscription/upgrade/', method: 'POST' },
      modify: { url: '/org/billing/subscription/modify/', method: 'PATCH' }
    }
  },
  codes: {
    list: { url: '/org/discount-codes/', method: 'GET' },
    get: { url: '/org/discount-codes/:id/', method: 'GET' },
    remove: { url: '/org/discount-codes/:id/', method: 'DELETE' },
    bulk_remove: { url: '/org/discount-codes/bulk-delete/', method: 'DELETE' },
    activate: { url: '/org/discount-codes/:id/activate/', method: 'PATCH' },
    bulk_activate: { url: '/org/discount-codes/bulk-activate/', method: 'PATCH' },
    assign_user: { url: '/org/discount-codes/:id/assign/', method: 'PATCH' },
    deactivate: { url: '/org/discount-codes/:id/deactivate/', method: 'PATCH' },
    bulk_deactivate: { url: '/org/discount-codes/bulk-deactivate/', method: 'PATCH' },
    create: {
      basic: { url: '/org/discount-codes/basic/', method: 'POST' },                 //amount of products/order
      bxgy: { url: '/org/discount-codes/bxgy/', method: 'POST' },                   //buy x get y
      free_shipping: { url: '/org/discount-codes/free_shipping/', method: 'POST' }  //free shipping
    },
    edit: { url: '/org/discount-codes/:id/', method: 'PATCH' },
    random: { url: '/org/discount-codes/random-code/', method: 'GET' }
  },
  reimbursements: {
    list: { url: '/org/shopping-reimbursements/', method: 'GET' },
    create: { url: '/org/shopping-reimbursements/', method: 'POST' },
    end: { url: '/org/shopping-reimbursements/end/', method: 'PUT' },
    check_balance: { url: '/org/shopping-reimbursements/check_balance/', method: 'POST' }
  },
  lookbooks: {
    limits: { url: '/org/lookbooks/limits/', method: 'GET' },
    list: { url: '/org/lookbooks/', method: 'GET' },
    create: { url: '/org/lookbooks/', method: 'POST' },
    get: { url: '/org/lookbooks/:id/', method: 'GET' },
    updatePatch: { url: '/org/lookbooks/drafts/:id/', method: 'PATCH' },
    delete: { url: '/org/lookbooks/drafts/:id/', method: 'DELETE' },
    updatePublishedPatch: { url: '/org/lookbooks/published/:id/', method: 'PATCH' },
    addUser: { url: '/org/lookbooks/:id/users/', method: 'PATCH' },
    users: { url: '/org/lookbooks/:id/users/', method: 'GET' },
    summary: { url: '/org/lookbooks/:id/summary/', method: 'GET' },
    tracking: {
      detectCarrier: { url: '/org/lookbooks/tracking/detect-carrier/', method: 'POST' }
    },
    orders: {
      get: { url: '/org/lookbooks/:id/orders/:orderId/', method: 'GET' },
      update: { url: '/org/lookbooks/:id/orders/:orderId/', method: 'PATCH' },
      handoffShopify: { url: '/org/lookbooks/:id/orders/:orderId/handoff-shopify/', method: 'POST' },
      markPlaced: { url: '/org/lookbooks/:id/orders/:orderId/mark-placed/', method: 'POST' },
      items: {
        get: { url: '/org/lookbooks/:id/orders/:orderId/items/:itemId/', method: 'GET' },
        update: { url: '/org/lookbooks/:id/orders/:orderId/items/:itemId/', method: 'PATCH' }
      },
      fulfillments: {
        create: { url: '/org/lookbooks/:id/orders/:orderId/fulfillments/', method: 'POST' },
        update: { url: '/org/lookbooks/:id/orders/:orderId/fulfillments/:fulfillmentId/', method: 'PATCH' },
        packages: {
          update: { url: '/org/lookbooks/:id/orders/:orderId/fulfillments/:fulfillmentId/packages/:packageId/', method: 'PATCH' }
        }
      }
    }
  },
  links: {
    get_meta: { url: '/org/links/meta/', method: 'POST' }
  }
};